import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';

import { AppContext } from 'context/AppContext';

import { Embed as EmbedElem } from './Embed.styles';

const Embed = ({ title, embed }) => {
  const { hideCookieBar, updateAppState } = useContext(AppContext);
  const [hasCookie, setHasCookie] = useState(false);

  useEffect(() => {
    setHasCookie(Cookies.get('sfnAcceptThirdParty'));
  }, [hideCookieBar]);

  const toggleModal = () => {
    document.body.classList.toggle('modal-open');
    updateAppState((state) => {
      return {
        ...state,
        openModal: !state.openModal,
        showCookieModal: !state.showCookieModal,
      };
    });
  };

  return hasCookie ? (
    <>
      {title && <h3 className="mb-4 lg:mb-8">{title}</h3>}
      <EmbedElem
        className="relative block overflow-hidden p-0 w-full rounded-lg"
        dangerouslySetInnerHTML={{ __html: embed }}
      />
    </>
  ) : (
    <div className="h-20 w-full bg-basic-200">
      <div className="flex flex-col items-center justify-center h-full">
        <p>U kunt deze inhoud niet zien vanwege de cookievoorkeuren.</p>
        <div className="w-full text-center">
          <button className="text-primary" type="button" onClick={toggleModal}>
            Pas cookievoorkeuren aan
          </button>
        </div>
      </div>
    </div>
  );
};

Embed.defaultProps = {
  title: '',
};

Embed.propTypes = {
  title: PropTypes.string,
  embed: PropTypes.string.isRequired,
};

export default Embed;
